import React from 'react';

import { ThresholdType, TotalItemConditionType, totalItemsConditionTypes } from '../../models';
import { useDiscountWizardStateContext } from '../state';

import { getRequirementsFromRequirementStepState } from './helpers';

export function Condition({ requirement }: { requirement: number | 'reward' }) {
  const { requirementsStepState, rewardsStepState } = useDiscountWizardStateContext();

  const requirements = getRequirementsFromRequirementStepState(requirementsStepState);
  const state = requirement === 'reward' ? rewardsStepState.condition : requirements[requirement];

  // calculated text values
  const minimumItemsText = state.minimumItems === '' ? '_' : state.minimumItems;
  const maximumItemsText = state.maximumItems === '' ? '_' : state.maximumItems;
  const minimumGramsText = state.minimumGrams === '' ? '_' : state.minimumGrams;
  const minimumSpendText = state.minimumSpend === '' ? '_' : `$${state.minimumSpend}`;
  const totalItemsConditionText =
    totalItemsConditionTypes.find((type) => type.val === state.totalItemCondition)?.name || '';
  const conditionallyPluralItem = `item${state.minimumItems === 1 ? '' : 's'}`;
  const conditionallyPluralGram = `gram${state.minimumGrams === 1 ? '' : 's'}`;

  // conditional rendering conditions
  const showNoCondition = state.condition === ThresholdType.NoThreshold;
  const showTotalItemsDetails = state.condition === ThresholdType.NumberOfItems;
  const showTotalSpendDetails = state.condition === ThresholdType.SpendingAmount;
  const showTotalWeightDetails = state.condition === ThresholdType.ProductWeight;
  const showMaxItems = state.totalItemCondition === TotalItemConditionType.Between;

  return (
    <>
      {showNoCondition && 'No condition'}
      {showTotalItemsDetails && (
        <>
          {!showMaxItems && `${totalItemsConditionText} ${minimumItemsText} ${conditionallyPluralItem}`}
          {showMaxItems && `${totalItemsConditionText} ${minimumItemsText} and ${maximumItemsText} items`}
        </>
      )}
      {showTotalSpendDetails && `At least ${minimumSpendText} total spend`}
      {showTotalWeightDetails && `At least ${minimumGramsText} ${conditionallyPluralGram}`}
    </>
  );
}
